import { SlicePipe } from '@angular/common';
import { Component, HostListener, signal, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NewsItem, NewsItemComponent } from 'projects/login/src/app/layout/login-layout/components/news-item/news-item.component';

@Component({
  selector: 'pay-login-news-list',
  imports: [TranslatePipe, NewsItemComponent, SlicePipe],
  templateUrl: './news-list.component.html',
})
export class NewsListComponent {
  newsItems = input<NewsItem[]>([]);
  sliceLength = signal(this.getNumForScreenHeight(document.documentElement.clientHeight));

  @HostListener('window:resize')
  onResize(): void {
    this.sliceLength.set(this.getNumForScreenHeight(document.documentElement.clientHeight));
  }

  getNumForScreenHeight(screenHeight: number) {
    return screenHeight > 1000 ? 3 : screenHeight > 800 ? 2 : 1;
  }
}
